import { Doc } from '@dadohr/shared/domainTypes/document';
import {
  AutomationActionStatus,
  IExperience,
  IExperienceTemplate
} from '@dadohr/shared/domainTypes/experience';
import { keyBy } from 'lodash';
import { toDenormalizedAutomationAction } from '../../../../../../services/experiences/instance';
import type { ExperienceProblemData } from '../../InstanceProblems';

export const collectAutomationIssues = (
  tpl: Doc<IExperienceTemplate>,
  d: Doc<IExperience>
) => {
  const automationsByTplId = keyBy(tpl.data.automations, (a) => a.id);
  const autoIssues: ExperienceProblemData[] = [];
  Object.entries(d.data.automations).forEach(([automationTplId, a]) => {
    Object.values(a.actions).forEach((action) => {
      if (action.status === AutomationActionStatus.ERROR) {
        const automationTpl = automationsByTplId[automationTplId];
        if (!automationTpl) {
          console.warn('Automation Tpl not found');
          return;
        }
        const actionTpl = automationTpl.actions.find(
          (ac) => ac.id === action.templateId
        );
        if (!actionTpl) {
          console.warn('Action Tpl not found');
          return;
        }
        const denormalized = toDenormalizedAutomationAction(actionTpl, action);
        if (!denormalized) {
          console.warn('Failed to denormalize action');
          return;
        }
        autoIssues.push({
          tpl,
          type: 'AUTOMATION',
          instance: d,
          id: denormalized.id,
          automationTpl,
          actionTpl,
          action,
          denormalized
        });
      }
    });
  });
  return autoIssues;
};
